module.exports = __webpack_public_path__ + "static/media/mainbg.347c3c6c.png";